import React, {useState} from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import Monetario from '../Monetario'
import colorChats from '../../lib/colorChats'

export 

const StackedBar = ({ title, color, dados }) => {

  const [totalGeralG, setTotalGeralG] = useState(0)

  const options = {
    legend: {
      display: true,
      labels: {
        boxWidth: 10,
        padding: 5,
      },
    },
    // tooltips: {
    //   enabled: true,
    //   callbacks: {
    //     label: function(tooltipItem, data) {

    //       var index = tooltipItem['index'],
    //           datasetIndex = tooltipItem['datasetIndex'];
    //       console.log(tooltipItem['index']);
    //       console.log(data.datasets[tooltipItem['datasetIndex']].data);

    //       var label = parseFloat(data.datasets[tooltipItem.datasetIndex].data[tooltipItem['index']]).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 00,00'
    //       console.log(label);

    //       var dataset = data.datasets[tooltipItem['datasetIndex']];
    //       var meta = dataset._meta[Object.keys(dataset._meta)[0]];
    //       console.log(meta);
    //       // var total = meta.total;
    //     }
    //   }
    // },
    plugins: {
      title: {
        display:  true,
        text:     'Pagamento Por Loja',
      },
    },
    responsive: true,
    scales: {
      xAxes: [{
        stacked: true,
      }],
      yAxes: [{
          ticks: {
            beginAtZero: true
          },
          stacked: true,
      }]
    }
  }

  var datasets      = [],
      totalGrafico  = 0,
      totalGeral    = 0

  let data = {
    labels:   [],
    datasets: [],
  }

  if ((!dados.lojas)&&(dados.dados)) {


    var colorGrafico = 1

    Object.values(dados.dados).map((value, index) => {

      totalGrafico  = 0

      for(var i = 0; i < value.lista.length; i++) {
        totalGrafico += parseFloat(value.lista[i])
      }

      // console.log(value.fantasia+' ('+totalGrafico+')')
      // label:  value.fantasia+' '+parseFloat(totalGrafico).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),

      datasets.push({
      label:  value.fantasia+' '+parseFloat(totalGrafico).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
        data:   value.lista,
        backgroundColor: colorChats.vivida[colorGrafico],
      })
      colorGrafico++
      totalGeral += totalGrafico
    })

    data = {
      labels:   dados.forma,
      datasets: datasets,
    };
  }

  return (
    <Card className='mb-0 mt-2'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor"><Monetario valor={totalGeral}/></div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Bar
          data={data}
          options={options}
          width={550}
          height={250}
        />
      </CardBody>
    </Card>
  )

}

export default StackedBar
